import { Component, OnInit } from '@angular/core';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, takeWhile, tap } from 'rxjs/operators';
import { LoginAuth0Service } from '../services/login-auth0.service';

@Component({
  selector: 'app-login',
  templateUrl: './login-auth0.component.html',
  styleUrls: ['./login-auth0.component.scss']
})
export class LoginAuth0Component implements OnInit {
  isAuthenticated$: Observable<boolean>;
  countdown$!: Observable<number>;

  constructor(
    private loginService: LoginAuth0Service
  ) {
    this.isAuthenticated$ = this.loginService.isAuthenticated();
  }

  ngOnInit(): void {
    this.countdown$ = this.isAuthenticated$.pipe(
      switchMap(isAuth => {
        if (isAuth) {
          return timer(0, 1000).pipe(
            map(n => 10 - n),
            takeWhile(count => count >= 0, true),
            tap(count => {
              if (count === 0) {
                this.loginWithRedirect();
              }
            })
          );
        }
        return of(-1);
      })
    );
  }

  loginWithRedirect(): void {
    this.loginService.login(null as unknown as any).subscribe();
  }

  logout(): void {
    this.loginService.logout().subscribe();
  }

}
